module.exports = __webpack_public_path__ + "img/inspark-logo.573465ef.svg";